<template>
  <div>
    <v-select
        label="Выберите ключ / сертификат"
        :items="certificateDropdownOptions"
        @change="onCertificateChanged"
        v-model="certificate"
    >
      <template v-slot:no-data>
        <h5 class="text-center">Нет ключей для выбора</h5>
      </template>

      <template v-slot:item="{item}">
        <v-card flat width="100%" class="mb-2">
          <v-card-text class="pa-0">
            <div class="subtitle-1">
              <span class="font-weight-light">Владелец:</span> <span class="font-weight-bold float-right">{{ item.value.issuedPerson.toUpperCase() }}</span><br>
              <span class="font-weight-light">Организация:</span> <span class="font-weight-bold float-right">{{ item.text.toUpperCase() }}</span> <br>
              <span class="font-weight-light">Серия:</span> <span class="font-weight-bold float-right">{{ item.value.serialNumber }}</span>  <br>
              <span class="font-weight-light">Инн:</span> <span class="font-weight-bold float-right">{{ item.value.innNumber }}</span>  <br>
              <span class="font-weight-light">Активен до:</span> <span class="font-weight-bold float-right">{{ item.value.validEndDate.toLocaleDateString() }}</span>
            </div>
          </v-card-text>

          <v-divider class="my-1" color="yellow" />
        </v-card>
      </template>
    </v-select>

    <v-dialog
        v-model="retryDialog"
        max-width="480"
        :persistent="true"
    >
      <v-card>
        <v-card-title class="headline">
          Ошибка при активации ключа.
        </v-card-title>

        <v-card-text>
          Попробуйте ещё раз ввести пароль ключа
        </v-card-text>

        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn
              color="warning darken-1"
              text
              @click="onRetryCancel"
          >
            Отменить
          </v-btn>
          <v-btn
              color="primary darken-1"
              text
              @click="activateCertificate()"
          >
            Попробую ещё раз
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import EImzo from '@/plugins/eimzo'

import _ from 'underscore'

export default {
  name: 'ActivateCertificate',
  data() {
    return {
      retryDialog: false,
      certificate: null
    }
  },
  computed: {
    certificates() {
      return EImzo.certificates;
    },
    activeCertificates() {
      const nowTime = (new Date()).getTime();

      return _.filter(this.certificates, certificate => {
        const certificateEndTime = certificate.validEndDate.getTime();

        return certificateEndTime > nowTime;
      });
    },
    certificateDropdownOptions() {
      return _.map(this.activeCertificates, activeCertificate => {
        return {
          text: activeCertificate.companyName || activeCertificate.issuedPerson,
          value: activeCertificate
        };
      });
    }
  },
  methods: {
    onCertificateChanged() {
      this.$store.commit('unsetLoadedCertificate');
      if (this.certificate)
        this.activateCertificate();
    },

    activateCertificate() {
      EImzo.activateCertificate(this.certificate)
          .then((activatedCertificate) => {
            EImzo.createPkcs7('activation', activatedCertificate)
                .then(() => {
                  this.retryDialog = false;
                  this.$store.commit('setLoadedCertificate', activatedCertificate);
                  this.$emit('activated');
                }, () => {
                  this.retryDialog = true;
                });
          }, () => {
            window.console.log('Error on activateCertificate');
          });
    },
    onRetryCancel() {
      this.certificate = null;
      this.retryDialog = false;
      this.$emit("cancel");
    }
  }
}
</script>